module.exports = __webpack_public_path__ + "static/media/inner-promo-banner.4f2c998e.jpg";